'use strict';

$(document).ready(function () {
    $('.main-slider').each(function () {
        var $this = $(this);
        var childCount = $this.find('.sub-slider').length;

        if (childCount > 1) {
            $this.addClass('install-slick');
            $('.install-slick').slick({
                dots: false,
                infinite: false,
                speed: 500,
                fade: false,
                cssEase: 'linear',
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
            });
        }
    });
});
